import React from "react";
import { Check, X } from "lucide-react";
import { Section, Eyebrow, Reveal, KW } from "./shared";
import { WHO_FOR } from "../../lib/site";

export default function WhoFor() {
  return (
    <Section id="who-for" bg="bg-brand-paleyellow">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#0B31EB">Fit Check</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          Is YouTube Lead Generation Mastery <KW c="#0B31EB">Right for You?</KW>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6 mt-12 items-start">
        <Reveal>
          <div className="rounded-[28px] border-2 border-brand-black bg-white p-7 sm:p-9" style={{ boxShadow: "8px 10px 0 #4CAF48" }}>
            <p className="font-display text-2xl text-brand-green">This Program Is for You If:</p>
            <ul className="mt-5 space-y-3">
              {WHO_FOR.yes.map((y) => (
                <li key={y} className="flex items-start gap-3">
                  <span className="mt-0.5 h-6 w-6 rounded-full bg-brand-green flex items-center justify-center shrink-0"><Check size={14} className="text-white" /></span>
                  <span className="text-sm sm:text-base">{y}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-[28px] border-2 border-brand-black bg-white p-7 sm:p-9" style={{ boxShadow: "8px 10px 0 #E90019" }}>
            <p className="font-display text-2xl text-brand-red">This Program Is Not for You If:</p>
            <ul className="mt-5 space-y-3">
              {WHO_FOR.no.map((n) => (
                <li key={n} className="flex items-start gap-3">
                  <span className="mt-0.5 h-6 w-6 rounded-full bg-brand-red/15 flex items-center justify-center shrink-0"><X size={14} className="text-brand-red" /></span>
                  <span className="text-sm sm:text-base text-brand-ink/70">{n}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <p className="text-center font-serif-e text-xl sm:text-2xl mt-10">
          This is not a get-rich-quick YouTube course. It is a <span className="font-bold text-brand-blue">build-something-valuable</span> program.
        </p>
      </Reveal>
    </Section>
  );
}
